export const quillConfig = {
    magicUrl: true,
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{color: []}],
            ['link'],
            ['clean'],
        ],
    },
    clipboard: {
        matchVisual: false,
    },
};
